export default "/images/tryg.png?5f2b6c06f84c16631f6b57ab136e44de";